/**
 * Logo Stella Cars — utilise les PNG officiels.
 * `full` = lockup horizontal (clair en dark mode, noir en light mode).
 * `mark` = icone carre.
 */
import { motion } from 'framer-motion';
import { useTheme } from '../lib/theme';

interface LogoProps {
  variant?: 'full' | 'mark';
  className?: string;
  animated?: boolean;
  /** Force un logo specifique au lieu de suivre le theme. */
  forceDark?: boolean;
}

export function Logo({ variant = 'full', className = '', animated = false, forceDark }: LogoProps) {
  const { theme } = useTheme();
  let src: string;
  if (variant === 'mark') {
    src = '/logo-mark.png';
  } else {
    src = theme === 'light' && !forceDark ? '/logo-dark.png' : '/logo.png';
  }
  const alt = 'Stella Cars';

  if (!animated) {
    return <img src={src} alt={alt} className={className} draggable={false} />;
  }

  return (
    <motion.img
      src={src}
      alt={alt}
      draggable={false}
      className={className}
      initial={{ opacity: 0, y: 6, scale: 0.98 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
    />
  );
}

